// #84 - client-side filter for the downline tree (the whole tree is already in
// the browser, so no server round-trip). Every whitespace-separated term must
// match: an agency matches on its name; an agent matches on name, NPN, or
// email. An agency whose own name matches keeps its whole subtree; otherwise
// it is kept (pruned) only when something beneath it matches. Totals are
// recomputed on the pruned tree so the count chips stay truthful.
const matches = (terms, ...fields) => {
  const hay = fields.filter(Boolean).join(" ").toLowerCase();
  return terms.every((term) => hay.includes(term));
};

export const parseTerms = (query) =>
  String(query || "")
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);

export const filterTree = (node, terms) => {
  if (!terms.length) return node;
  if (matches(terms, node.name)) return node;
  const children = node.children
    .map((child) => filterTree(child, terms))
    .filter(Boolean);
  const agents = node.agents.filter((agent) =>
    matches(terms, agent.firstName, agent.lastName, agent.npn, agent.email)
  );
  if (!children.length && !agents.length) return null;
  const totalAgents =
    agents.length + children.reduce((sum, child) => sum + child.totalAgents, 0);
  const totalAgencies =
    children.length +
    children.reduce((sum, child) => sum + child.totalAgencies, 0);
  return { ...node, children, agents, totalAgents, totalAgencies };
};
